import { Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";

import { Button } from "@/client/components/ui/button";
import { getTheme, setTheme, subscribeTheme, type Theme } from "@/client/lib/theme";

/** Header control that flips between light and dark and remembers the choice. */
export function ThemeToggle() {
  // Seed from the theme already applied by theme-init.js / OS preference (not a
  // hard-coded "light"), so the first render's aria-label and the first click
  // act on the real current theme.
  const [theme, setThemeState] = useState<Theme>(getTheme);

  // Stay in sync when the theme is toggled in another tab.
  useEffect(() => subscribeTheme(setThemeState), []);

  const toggle = () => {
    const next: Theme = theme === "dark" ? "light" : "dark";
    setTheme(next);
    setThemeState(next);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      title="Toggle light / dark"
    >
      <Sun className="hidden size-4 dark:block" />
      <Moon className="block size-4 dark:hidden" />
    </Button>
  );
}
